import { render, staticRenderFns } from "./ConferenceManagement.vue?vue&type=template&id=77d4a5ad&scoped=true"
import script from "./ConferenceManagement.vue?vue&type=script&lang=ts"
export * from "./ConferenceManagement.vue?vue&type=script&lang=ts"
import style0 from "./ConferenceManagement.vue?vue&type=style&index=0&id=77d4a5ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4a5ad",
  null
  
)

export default component.exports